















import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class UiSelectSortOptions extends BaseComponent {
  @Prop()
  public sortOptions: Array<any>;

  @Prop()
  public sortBy: string;

  @Prop()
  public descending = false;

  sortBySelected = null;
  descendingSelected = null;

  @Watch('sortBy', { immediate: true })
  sortByWatch(v) {
    this.sortBySelected = v;
  }

  @Watch('descending', { immediate: true })
  descendingWatch(v) {
    this.descendingSelected = v;
  }

  sortAscDescChange() {
    this.descendingSelected = !this.descendingSelected;
    this.emitChange();
  }

  emitChange() {
    this.$emit('change', this.sortBySelected, this.descendingSelected);
  }
}
